// extracted by mini-css-extract-plugin
export var closeButton = "_7n-0";